<template>
  <BaseDialog
    ref="baseDialog"
    modal-id="deleteRewardPointDialog"
    :title="$t('reward_points.delete.title')"
    :confirm-text="$t('common.delete')"
    confirm-variant="danger"
    :loading="loading"
    @confirm="handleConfirm"
    @cancel="handleCancel"
  >
    <template #body>
      <p v-html="$t('reward_points.delete.message', { name: pointName })"></p>
      <p class="text-danger">
        <i class="fas fa-exclamation-triangle me-2"></i>
        {{ $t('reward_points.delete.warning') }}
      </p>
    </template>
  </BaseDialog>
</template>

<script setup>
import { ref, defineEmits, defineExpose } from 'vue'
import BaseDialog from '@/components/common/BaseDialog.vue'

const baseDialog = ref(null)
const loading = ref(false)
const pointName = ref('')

const openDialog = (name = '') => {
  pointName.value = name
  loading.value = false
  baseDialog.value?.openDialog()
}

const closeDialog = () => {
  baseDialog.value?.closeDialog()
}

const emit = defineEmits(['delete'])

const handleConfirm = async () => {
  loading.value = true
  try {
    emit('delete')
  } catch (error) {
    loading.value = false
    throw error 
  }
}

const handleCancel = () => {
  loading.value = false
}

defineExpose({ openDialog, closeDialog })
</script>